import React, { useState, useEffect } from "react";
import reportAPI from "../../../../api/report";
import { FilterYearType } from "../common/ReportFilters";
import { ButtonExcel } from "../../../../utils/buttonLoadExcel";
import {
  FLEXDROPDOWN,
  SCREENIPAD,
  STYLEBODY,
  STYLEHEAD,
  TABLE,
  LEFTTABLE,
  THTABLE,
  RIGHTTABLE,
  TRTABLE,
  TXLEFT,
  TXCENTER,
} from "../../../../utils/useStyle";
import { formatSucAttempt } from "../../utils/Report.Format";
import { ExcelSucAttempt } from "../../functions/Report.ExportSucAttempt";

const ReportCountSucAttempt = ({ userDept }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    ad_01: 0,
    ad_02: 0,
    ad_03: 0,
    ad_04: 0,
    //
    kid_01: 0,
    kid_02: 0,
    kid_03: 0,
    kid_04: 0,
  });

  const [year, setYear] = useState({
    label: "ทุกปี",
    value: "ALL",
  });
  const [type, setType] = useState({
    label: "-",
    value: "NONE",
  });

  useEffect(() => {
    // Use backend API instead of frontend processing
    const fetchData = async () => {
      try {
        const response = await reportAPI.getSucAttemptReport({
          year: String(year?.value),
          type: String(type?.value),
          user_department: userDept,
        });
        if (response?.success) {
          setData(response.data);
        }
      } catch (error) {
        console.error("Error fetching suc attempt report:", error);
      }
    };
    fetchData();
  }, [year, type, userDept]);

  const tabel = [
    { name: "1 attempt", adult: data?.ad_01, kid: data?.kid_01 },
    { name: "2 attempts", adult: data?.ad_02, kid: data?.kid_02 },
    { name: "3 attempts", adult: data?.ad_03, kid: data?.kid_03 },
    { name: "4 attempts", adult: data?.ad_04, kid: data?.kid_04 },
  ];

  return (
    <div className="my-20">
      <div className={SCREENIPAD}>
        <div className={STYLEHEAD}>
          รายงานจำนวนครั้งในการทำหัตถการ
          <div className={STYLEBODY}>
            ของปี {year?.label} แยกตามประเภทของสาย {type?.label}
          </div>
        </div>
        <div className={FLEXDROPDOWN}>
          <FilterYearType
            year={year}
            setYear={setYear}
            type={type}
            setType={setType}
          />
          <ButtonExcel
            text={"DOWNLOAD EXCEL"}
            onClick={() => {
              ExcelSucAttempt(formatSucAttempt(data), year, type, setLoading);
            }}
            loading={loading}
          />
        </div>
      </div>

      <table className={TABLE}>
        <thead>
          <tr>
            <th className={LEFTTABLE}>Procedural Attempts</th>
            <th className={THTABLE}> Children </th>
            <th className={RIGHTTABLE}> Adults </th>
          </tr>
        </thead>
        <tbody>
          {tabel?.map((item, index) => (
            <tr key={index} className={TRTABLE}>
              <td className={TXLEFT}> {item?.name}</td>
              <td className={TXCENTER}>{item?.kid}</td>
              <td className={TXCENTER}>{item?.adult}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ReportCountSucAttempt;
